'use client';
import { GroqImage } from '@/helpers/Image';
import { GROQButton, GROQImage } from '@/sanity/lib/definitions';
import { useIsMobile } from '@/hooks/useIsMobile';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { motion } from 'framer-motion';
import { PortableText } from 'next-sanity';
import { PortableTextBlock } from 'sanity';

interface IBigWatch {
  title: PortableTextBlock[];
  image: GROQImage;
  imageMobile: GROQImage;
}

export default function BigWatchSection({
  title,
  image,
  imageMobile,
}: IBigWatch) {
  const isMobile = useIsMobile();

  return (
    <section id="big-watch-section" className="container lg:max-w-none flex flex-col justify-end min-h-[83rem] lg:min-h-[135rem] gap-[8rem] lg:gap-[18rem] pb-[10.25rem] lg:pb-[21.12rem] overflow-clip relative">
      <motion.div
        initial={{ opacity: 0.3, y: '7rem' }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{
          amount: 0.3,
        }}
        transition={{ duration: 1.5, ease: [0.25, 1, 0.5, 1] }}
        className="flex relative z-10 w-full lg:w-[58.125rem] flex-col gap-[2rem] lg:gap-[3.62rem] text-center items-center justify-center mx-auto px-[2.75rem] lg:px-0
        prose-headings:text-[6rem] prose-headings:text-white prose-headings:font-[300] prose-headings:uppercase prose-headings:leading-[110%] lg:prose-headings:leading-[120%]
        prose-p:text-[2rem] prose-p:text-[#F2F0EF]/70 prose-p:font-[300] prose-p:leading-[160%]"
      >
        {title && (
          <PortableText value={title} components={richTextComponent} />
        )}
      </motion.div>

      <div className="w-full h-[57.5rem] absolute top-0 left-0 z-[1] pointer-events-none select-none bg-gradient-to-t from-black via-transparent to-transparent lg:hidden"/>

      <motion.div
        className="w-full h-[57.5rem] lg:h-full absolute z-0 inset-0 pointer-events-none select-none"
        initial={{ opacity: 0.1 }}
        whileInView={{ opacity: 1 }}
        viewport={{
          amount: 0.3
        }}
        transition={{
          duration: 1.2,
          ease: [0.76, 0, 0.24, 1],
        }}
      >

        {image && (
          <GroqImage
            src={image}
            alt={image?.name}
            className="!w-full !h-full !object-cover relative z-0"
            loading="eager"
          />
        )}
      </motion.div>
    </section>
  );
}
